module.exports = __webpack_public_path__ + "static/frame-2c84aef44cfb4dc3beb5485e1771034d.png";